import React, { useEffect, useState } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import classes from './ScheduleSend.module.scss';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import moment from 'moment-timezone';

const ScheduleSend = ({ isModalOpen, openModal, setMessageSchedule, isEditing }) => {

  const [schedule, setSchedule] = useState(moment.tz('America/Los_Angeles').add(1, 'hour'))

  const attachSchedule = () => {
    setMessageSchedule(schedule);
    openModal(false);
  }

  return (
    <Modal backdrop="static" className={classes.modalDialog} isOpen={isModalOpen} toggle={() => openModal(false)}>
      <ModalHeader toggle={() => openModal(false)}>Schedule Send</ModalHeader>
      <ModalBody>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DemoContainer
            components={[
              'MobileDateTimePicker'
            ]}
          >
            <DemoItem label="Select Schedule Time">
              <MobileDateTimePicker maxDateTime={moment.tz('America/Los_Angeles').add(7, 'days')} minDateTime={moment.tz('America/Los_Angeles').add(1, 'hour')} disablePast={true} onChange={(e) => setSchedule(e)} value={schedule} defaultValue={schedule} />
            </DemoItem>
          </DemoContainer>
        </LocalizationProvider>
      </ModalBody>
      <ModalFooter>
        <Button  color="primary" onClick={attachSchedule}>
          Schedule
        </Button>
        <Button color="secondary" onClick={() => openModal(false)}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ScheduleSend